import React, { useEffect } from 'react'
import { useFormContext } from 'react-jsonschema-form-validation';

export const FormValidator = ({ validateCallback }) => {

    const { valid } = useFormContext();

    useEffect(() => {
        validateCallback(valid)

    }, [valid])

    return (
        null
    );
}
